// extracted by mini-css-extract-plugin
export var subtitle = "_cu-2";
export var title = "_cu-0";
export var titleNoWrap = "_cu-1";